module.exports = __webpack_public_path__ + "img/SitePhotograph.d142b5fb.jpg";